export default "__VITE_ASSET__EvuW72sq__"